import Chip from "../Chip"
import { IChipListProps } from "../types"
import "./ChipList.scss"

const ChipList = ({
  control,
  list,
  type = "radio",
  listStyle = "wrap",
  clickCallback,
  modifier
}: IChipListProps) => {
  const renderList = list.map(({ isDisabled, id, label, name, value }) => {
    return (
      <Chip
        control={control}
        id={id}
        isDisabled={isDisabled}
        key={id}
        label={label}
        name={name}
        type={type}
        value={value}
        clickCallback={clickCallback}
        modifier={modifier}
      />
    )
  })

  return (
    <div className={`ds-chipList ds-chipList--${listStyle}`}>{renderList}</div>
  )
}

export default ChipList
